/**
 * The annual-prepay discount rate.
 *
 * **Why one constant occupies a file called `discount-eligibility.ts`.** This
 * module used to hold the whole verification-discount programme — the
 * nonprofit / education / open-source eligibility categories, the auto-screen,
 * the exclusive-program resolver, and the multiplicative stacking math for a 50%
 * verified discount. That programme was RETIRED (T35b / ADR-0365, operator
 * decision 2026-07-26): the dashboard surface it fed was reachable only by
 * guessing a URL, so the route, the page, the API resolver/service/repository and
 * the workflow state machine were deleted rather than left as dead reachable
 * surface (`quality-bar.md`).
 *
 * The annual-prepay rate below is a DIFFERENT programme and is very much live —
 * `apps/marketing/src/features/pricing-card/billing-period.ts` reads it to render
 * the "save 10% with annual" figure on the public pricing page, and
 * `scripts/verify/pricing-docs-truth.sh` (B22c) reads THIS PATH to assert the
 * rate has not drifted off the ADR-0103 ladder. That guard is a
 * `[ -f "$PRICING_CONST_FILE" ]` check, so moving the constant to a better-named
 * file would make it silently stop checking rather than fail — which is why the
 * filename stays put. Rename the file and the guard's path in the same change, or
 * not at all.
 */

/**
 * Annual-prepay discount. The canonical program is the ADR-0103 / AF-265 term
 * ladder — 10% / 18% / 25% for 1/2/3-year prepay — enforced for real billing in
 * `apps/api/.../annual-prepay-ledger.ts`. This shared module models the
 * **1-year base rate (10%)**; multi-year tiers are applied by the api ledger, not
 * here. (Was `0.15` — off-ladder — until the ADR-0103 reconciliation.)
 */
export const ANNUAL_PREPAY_DISCOUNT_FRACTION = 0.1;
